import { render, staticRenderFns } from "./CompanyPrivate.vue?vue&type=template&id=14bb0426&"
import script from "./CompanyPrivate.vue?vue&type=script&lang=js&"
export * from "./CompanyPrivate.vue?vue&type=script&lang=js&"
import style0 from "./CompanyPrivate.vue?vue&type=style&index=0&id=14bb0426&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports